var map = {
	"./TikTok.png": 3829,
	"./applePodcasts.png": 7500,
	"./bitchute.png": 5511,
	"./bittube.png": 7600,
	"./cashapp.png": 9881,
	"./discord.png": 7579,
	"./dlive.png": 9169,
	"./facebook.png": 8607,
	"./flote.png": 9767,
	"./github.png": 5798,
	"./instagram.png": 7479,
	"./lbry.png": 9058,
	"./linkedin.png": 1213,
	"./medium.png": 1382,
	"./memo.png": 7549,
	"./minds.png": 4984,
	"./openBazaar.png": 4646,
	"./open_bazaar.png": 3481,
	"./patreon.png": 4376,
	"./paypal.png": 1310,
	"./read.png": 3247,
	"./reddit.png": 2999,
	"./soundcloud.png": 7223,
	"./spotify.png": 261,
	"./steemit.png": 904,
	"./stitcher.png": 7869,
	"./telegram.png": 1778,
	"./twetch.png": 2106,
	"./twitch.png": 5678,
	"./twitter.png": 3686,
	"./web.png": 6561,
	"./youtube.png": 1259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7816;